import * as z from "zod";

/** Where the email this sign-in resumed is answered: the user's chat, nowhere (`none`), or not known yet. */
export const getAskRedoEmailSignInChat = {
  name: "getAskRedoEmailSignInChat" as const,
  input: z.object({ verificationId: z.string().regex(/^\d+$/) }),
  output: z.union([
    z.object({ status: z.literal("pending") }),
    z.object({ status: z.literal("none") }),
    z.object({ status: z.literal("chat"), emailThreadId: z.string() }),
  ]),
};
